import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { PsfPromoteOrShareRecruiterQuery, PsfPromoteOrShareRecruiterQueryVariables } from './recruiter.graphql';
import { PsfPromoteOrShareRecruiter } from './recruiter.graphql';

export async function getRecruiter({ gql }: UtilityContext, recruiterId: string) {
	return gql.fetch<PsfPromoteOrShareRecruiterQuery, PsfPromoteOrShareRecruiterQueryVariables>({
		query: PsfPromoteOrShareRecruiter,
		variables: { recruiterId },
		// we don't want to break the page on invalid recruiter id
		rejectOnError: false,
	});
}
